import { CheckboxFieldFragmentFragment } from '../../../../__generated__/graphql';
import CheckboxGroup from '../../../../components/CheckboxGroup';
import { Paragraph } from '../../../../components/Text';
import { useGravityFormsDispatch, useSelectCheckboxFieldValue, useSelectInitialized } from '../../state/hooks';
import ConditionalWrapper from '../ConditionalWrapper';
import FieldErrors from '../FieldErrors';
import FormFieldGridContainer from '../FormFieldGridContainer';

interface Props {
  field: CheckboxFieldFragmentFragment;
}

const CheckboxInput = ({ field }: Props) => {
  const {
    choices,
    conditionalLogic,
    databaseId,
    description,
    inputs,
    isRequired,
    label,
    layoutGridColumnSpan,
  } = field;

  const dispatch = useGravityFormsDispatch();

  const fieldValue = useSelectCheckboxFieldValue(databaseId);
  const initialized = useSelectInitialized();

  if (initialized && !fieldValue) {
    return null;
  }

  const checkboxInputs = choices?.map((choice, index) => ({ ...choice, id: inputs?.[index]?.id })) ?? [];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      checked,
      dataset: { id: dataId },
      value,
    } = e.target;
    const otherCheckboxValues = fieldValue?.checkboxValues.filter(
      checkboxValue => checkboxValue.inputId !== Number(dataId),
    ) ?? [];

    const newCheckboxValues = checked
      ? [...otherCheckboxValues, { inputId: Number(dataId), value }]
      : otherCheckboxValues;

    dispatch({
      payload: {
        checkboxValues: newCheckboxValues,
        id: databaseId,
      },
      type: 'updateCheckboxFieldValue',
    });
  };

  return (
    <ConditionalWrapper conditionalLogic={conditionalLogic}>
      <FormFieldGridContainer layoutGridColumnSpan={layoutGridColumnSpan}>
        <CheckboxGroup
          label={label ?? ''}
          options={checkboxInputs.map(checkboxInput => ({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'data-id': checkboxInput.id?.toString(),
            label: checkboxInput.text ?? '',
            name: checkboxInput.id?.toString(),
            onChange: handleChange,
            required: !!isRequired,
            value: checkboxInput.value ?? undefined,
          }))}
        />

        {description && <Paragraph>{description}</Paragraph>}

        <FieldErrors fieldId={databaseId} />
      </FormFieldGridContainer>
    </ConditionalWrapper>
  );
};

export default CheckboxInput;
